/**
 * Auth endpoint wrappers (the cookie-bearing surface).
 *
 * `refresh` is the linchpin: it's called on boot and on every 401
 * silent retry. `logout` is fired by the user-menu sign-out action.
 */
import { request } from './client';
import type { AuthTokenResponse } from './types';

export const authApi = {
  refresh(): Promise<AuthTokenResponse> {
    return request<AuthTokenResponse>('POST', '/api/auth/refresh', { json: {} });
  },

  logout(): Promise<void> {
    return request<void>('POST', '/api/auth/logout', { json: {} });
  },
};
